<template>
  <div class="login">
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      class="login-form"
    >
      <h3 class="title">应用发布管理中心</h3>

      <el-form-item prop="username">
        <el-input
          v-model="loginForm.username"
          type="email"
          style="width: 80%"
          auto-complete="off"
          placeholder="电子邮箱"
        >
          <svg-icon
            slot="prefix"
            icon-class="password"
            class="el-input__icon input-icon"
          />
        </el-input>
        <el-button
          size="medium"
          type="primary"
          style="width: 20%"
          @click.native.prevent="handlerMail"
        >
          <span v-if="!sending">发送</span>
          <span v-if="sending">发 送 中</span>
        </el-button>
      </el-form-item>
      <el-form-item prop="emailCode">
        <el-input
          v-model="loginForm.emailCode"
          type="text"
          auto-complete="off"
          placeholder="邮箱校验码"
        >
          <svg-icon
            slot="prefix"
            icon-class="password"
            class="el-input__icon input-icon"
          />
        </el-input>
      </el-form-item>
      <el-form-item prop="password" v-show="false">
        <el-input
          v-model="loginForm.password"
          type="password"
          auto-complete="off"
          placeholder="密码"
          @keyup.enter.native="handleLogin"
        >
          <svg-icon
            slot="prefix"
            icon-class="password"
            class="el-input__icon input-icon"
          />
        </el-input>
      </el-form-item>
      <el-form-item prop="code">
        <el-input
          v-model="loginForm.code"
          auto-complete="off"
          placeholder="验证码"
          style="width: 63%"
          @keyup.enter.native="handleLogin"
        >
          <svg-icon
            slot="prefix"
            icon-class="validCode"
            class="el-input__icon input-icon"
          />
        </el-input>
        <div class="login-code">
          <img :src="codeUrl" @click="getCode" />
        </div>
      </el-form-item>
      <el-checkbox
        v-if="false"
        v-model="loginForm.rememberMe"
        style="margin: 0px 0px 25px 0px"
        >记住密码</el-checkbox
      >
      <el-form-item style="width: 100%">
        <el-button
          :loading="loading"
          size="medium"
          type="primary"
          style="width: 100%"
          @click.native.prevent="handleLogin"
        >
          <span v-if="!loading">登 录</span>
          <span v-else>登 录 中...</span>
        </el-button>
      </el-form-item>
      <div>
        <el-link style="margin: 15px" type="primary" href="/register"
          >注册</el-link
        >
      </div>
    </el-form>

    <!--  底部  -->
    <div class="el-login-footer">
      <span>系统问题,应用发布申请：longfei.hu@zhiyoubao.com</span>
    </div>
  </div>
</template>

<script>
import { getCodeImg } from "@/api/login";
import Cookies from "js-cookie";
import { encrypt, decrypt } from "@/utils/jsencrypt";
import { validatorZybEmail } from "@/utils/common";
import { loginEmail } from "@/api/user/user";

export default {
  name: "Login",
  data() {
    let validatorZybEmail = (rule, value, callback) => {
      let pattern =
        /^[A-Za-z0-9\u4e00-\u9fa5.]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      let domains = ["zhiyoubao.com"];
      if (pattern.test(value)) {
        var domain = value.substring(value.indexOf("@") + 1);
        for (var i = 0; i < domains.length; i++) {
          if (domain == domains[i]) {
            callback();
          }
        }
      }
      callback(new Error("邮箱需要是公司邮箱!"));
    };
    return {
      codeUrl: "",
      cookiePassword: "",
      loginForm: {
        username: "",
        password: "",
        rememberMe: false,
        code: "",
        uuid: "",
        emailUuid: "",
        emailCode: "",
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", message: "用户名不能为空" },
          { validator: validatorZybEmail },
        ],
        emailCode: [
          { required: true, trigger: "blur", message: "请输入邮箱验证码" },
        ],
        //password: [
        // { required: true, trigger: "blur", message: "密码不能为空" },
        //],
        code: [
          { required: true, trigger: "change", message: "验证码不能为空" },
        ],
      },
      sending: false,
      loading: false,
      redirect: undefined,
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  created() {
    var ip = window.location.host;
    console.log("by", ip.split(":")[0]);
    this.getCode();
    this.getCookie();
  },
  methods: {
    getCode() {
      getCodeImg().then((res) => {
        this.codeUrl = "data:image/gif;base64," + res.img;
        this.loginForm.uuid = res.uuid;
      });
    },
    getCookie() {
      const username = Cookies.get("username");
      const password = Cookies.get("password");
      const rememberMe = Cookies.get("rememberMe");
      this.loginForm = {
        username: username === undefined ? this.loginForm.username : username,
        password:
          password === undefined ? this.loginForm.password : decrypt(password),
        rememberMe: rememberMe === undefined ? false : Boolean(rememberMe),
      };
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          if (this.loginForm.rememberMe) {
            Cookies.set("username", this.loginForm.username, { expires: 30 });
            Cookies.set("password", encrypt(this.loginForm.password), {
              expires: 30,
            });
            Cookies.set("rememberMe", this.loginForm.rememberMe, {
              expires: 30,
            });
          } else {
            Cookies.remove("username");
            Cookies.remove("password");
            Cookies.remove("rememberMe");
          }
          console.log("邮箱验证码", this.loginForm);
          this.$store
            .dispatch("Login", this.loginForm)
            .then(() => {
              console.log("登录成功");
              this.$router.push({ path: this.redirect || "/" });
            })
            .catch(() => {
              this.loading = false;
              this.getCode();
            });
        }
      });
    },
    handlerMail() {
      console.log("send", this.loginForm.username);
      if (validatorZybEmail(this.loginForm.username)) {
        this.sending = true;
        var that = this;
        loginEmail({ email: this.loginForm.username })
          .then((response) => {
            that.sending = false;
            console.log("获取校验码", response);
            if (response.data.emailSend) {
              that.loginForm.emailUuid = response.data.uuid;
              alert(response.msg);
            } else {
              alert(response.msg);
            }
          })
          .catch(() => {
            that.sending = false;
            alert("错误");
          });
      } else {
        alert("请输入公司邮箱地址");
      }
    },

    avert() {
      let myArray = new Array();
      myArray[1] = "6";
      myArray[13] = "7";
      console.log(myArray);
      myArray.forEach((element, index) => {
        console.log("a", index, myArray[index]);
      });
      for (let i = 0; i < 50; i++) {
        if (myArray[i] === undefined) {
          myArray[i] = "";
        }
        console.log(i, myArray[i]);
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss">
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-image: url("../assets/image/login-background.jpg");
  background-size: cover;
}
.title {
  margin: 0px auto 30px auto;
  text-align: center;
  color: #707070;
}

.login-form {
  border-radius: 6px;
  background: #ffffff;
  width: 400px;
  padding: 25px 25px 5px 25px;
  .el-input {
    height: 38px;
    input {
      height: 38px;
    }
  }
  .input-icon {
    height: 39px;
    width: 14px;
    margin-left: 2px;
  }
}
.login-tip {
  font-size: 13px;
  text-align: center;
  color: #bfbfbf;
}
.login-code {
  width: 33%;
  height: 38px;
  float: right;
  img {
    cursor: pointer;
    vertical-align: middle;
  }
}
.el-login-footer {
  height: 40px;
  line-height: 40px;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: #fff;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
}
</style>
